class Watson {
  instance = null
  messages = []
  agentMessages = []
  model = ''

  constructor(instance, messages, agentMessages) {
    this.instance = instance || {}
    this.messages = messages || []
    this.agentMessages = agentMessages || []
    this.model = instance?.model || ''
  }
  attachListeners() {
    this.instance.on({ type: 'send', handler: (event) => this.saveMessage(event) })
    this.instance.on({ type: 'receive', handler: (event) => this.saveMessage(event) })
    this.instance.on({ type: 'agent:send', handler: (event) => this.saveAgentMessage(event) })
    this.instance.on({ type: 'agent:receive', handler: (event) => this.saveAgentMessage(event) })
    this.instance.on({ type: 'history:begin', handler: (event) => this.saveHistory(event) })
  }

  getInstance() {
    return this.instance
  }

  setModel(model) {
    this.model = model
  }

  saveMessage(event) {
    this.messages.push(event.data)
  }

  saveAgentMessage(event) {
    this.agentMessages.push({
      ...event.data,
      agentNickname: (event.agentProfile && event.agentProfile.nickname) || 'Agent',
    })
  }

  createHistoryObject() {
    const history = {
      assistantMessages: this.messages
        .map((message) => {
          if (message.input?.text) {
            return { from: 'User', text: message.input.text }
          } else if (message.output?.generic?.length) {
            return message.output.generic.map((item) => ({
              from: message.agentNickname || 'Assistant',
              text: item.text || '',
            }))
          }
          return null
        })
        .flat()
        .filter(Boolean),
      agentMessages: this.agentMessages.map((msg) => ({
        from: msg.agentNickname,
        text: msg.output.generic?.[0]?.text || '',
      })),
    }

    return history
  }

  saveHistory(event) {
    this.messages.push(...event.messages)
  }

  open() {
    this.instance.requestFocus()
    this.instance.changeView({ mainWindow: true, launcher: false })
  }
  close() {
    this.instance.changeView({ mainWindow: false, launcher: false })
  }

  sendMessageHotspot(message) {
    this.sendMessage(message, true)
  }
  sendMessage(message, isHotspot = false) {
    this.instance.send({
      input: {
        message_type: 'text',
        text: message,
      },
      context: {
        skills: {
          ['actions skill']: {
            user_defined: {
              isHotspot,
              model: this.instance.model,
            },
          },
        },
      },
      silent: false,
    })
  }

  sendMessageSilent(message) {
    this.instance.send({ input: { text: `${message}` }, silent: false })
  }
}

export default Watson
